<template>
  <div>
    <Loader cover v-if="local.isProcessing"/>
    <CommonFilterForTable :parentState="state" @load-data="loadData"/>
    <ListTable/>
  </div>
</template>

<script>
  import {state, loadData} from './data';
  import ClassRoom from '@/store/modules/class-room/class-room/index';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.ClassRoom) state.registerModule(`ClassRoom`, ClassRoom);

  const {
    mapActions: mapClassRoomActions,
  } = createNamespacedHelpers(`ClassRoom`);

  export default {
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      CommonFilterForTable: () => import('@/components/shared/filters/CommonFilterForTable.vue'),
      ListTable: () => import('./subcomponents/ClassRoomList.vue'),
    },
    data() {
      return {
        state: state,
        local: state.local,
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapClassRoomActions({
        getClassRoomsByFilter: 'getClassRoomsByFilter',
      }),
      async loadData() {
        let func = {getClassRoomsByFilter: this.getClassRoomsByFilter};
        await loadData(func);
      }
    },
  }
</script>
